'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ScopeChangeNewCtrl
 * @description
 * # ScopeChangeNewCtrl
 * Registro de una solicitud de cambio de alcance a partir de un proyecto.
 */
angular.module('thothApp.controllers')
  .controller('ScopeChangeNewCtrl', [
  '$scope', '$state', '$stateParams', '$window', '$q', 'ScopeChangeRequest', 'Project', 'Client', 'ProductCatalog', 'ProjectTypeCatalog', 'Employee', 'User', 'GoogleApi', 'toaster',
  function ($scope, $state, $stateParams, $window, $q, ScopeChangeRequest, Project, Client, ProductCatalog, ProjectTypeCatalog, Employee, User, GoogleApi, toaster) {
      $scope.projectId = $stateParams.projectId;
      $scope.saving = false;

      $scope.requestHash = { 'scope_change_request': { 'origin_project_id': $stateParams.projectId } };

      // El solicitante llega propuesto con el dueño de la sesión.
      if ('apiUser' in $window.localStorage) {
        var sessionUser = JSON.parse($window.localStorage.apiUser);
        $scope.selectedRequester = { id: sessionUser.id, name: sessionUser.name };
        $scope.requestHash.scope_change_request.requested_by_id = sessionUser.id;
      }

      // Se busca en el servidor en vez de traer los 213 usuarios: el listado
      // completo tarda más de quince segundos.
      $scope.userSearch = function (searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var deferred = $q.defer();
        User.index({ params: { search: searchQuery } }).then(function (response) {
          deferred.resolve(response.data.users);
        }, function (error) {
          User.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.requesterChanged = function (user) {
        $scope.requestHash.scope_change_request.requested_by_id = user ? user.id : undefined;
      };

      // Cliente, producto, tipo, RAPE y PM se proponen desde el proyecto origen,
      // igual que hace extend_project al derivar un proyecto. Siguen editables.
      Project.find($stateParams.projectId).then(function(response) {
        var project = response.data.project;
        $scope.originProject = project;

        angular.extend($scope.requestHash.scope_change_request, {
          'name': project.name + ' - Cambio de Alcance',
          'client_id': project.client_id,
          'product_catalog_id': project.product_catalog_id,
          'project_type_catalog_id': project.project_type_catalog_id,
          'rape_id': project.rape_id,
          'pm_id': project.pm_id
        });
      }, function(error) {
        Project.error(error);
      });

      Employee.index({ params: { by_rape: true, by_status: true, per_page: 'all' } }).then(function(response) {
        $scope.rapeList = response.data.employees;
      }, function(error) {
        Employee.error(error);
      });

      Employee.index({ params: { by_pm: true, by_status: true, per_page: 'all' } }).then(function(response) {
        $scope.pmList = response.data.employees;
        $scope.pmList.unshift({ id: null, name: 'No Aplica' });
      }, function(error) {
        Employee.error(error);
      });


      Client.index({ params: { per_page: 'all' } }).then(function(response) {
        $scope.clients = response.data.clients;
      }, function(error) {
        Client.error(error);
      });

      ProductCatalog.index({ params: { per_page: 'all' } }).then(function(response) {
        $scope.products = response.data.products;
      }, function(error) {
        ProductCatalog.error(error);
      });

      ProjectTypeCatalog.index({ params: { per_page: 'all' } }).then(function(response) {
        $scope.projectTypes = response.data.project_types;
      }, function(error) {
        ProjectTypeCatalog.error(error);
      });

      $scope.cancel = function() {
        $state.go('app.projects.show', { projectId: $stateParams.projectId });
      };

      // El documento va a la carpeta de Requerimientos del proyecto en Drive.
      // Se busca por fragmento del nombre porque lleva el codigo delante, y
      // porque la estructura de carpetas va a cambiar de nombre mas adelante.
      // Los errores de Google no tienen la forma que espera el manejador del
      // SIA, asi que se traducen a un mensaje antes de propagarlos.
      const driveError = function(error) {
        var status = error && (error.status || (error.result && error.result.error && error.result.error.code));

        if (status === 401 || status === 403) {
          return 'Google rechazó la petición. La sesión de Google caducó o no tiene permiso sobre esa carpeta.';
        }
        if (status === 404) {
          return 'No se encontró la carpeta del proyecto en Google Drive.';
        }
        return 'No se pudo subir el documento a Google Drive.';
      };

      const uploadDocument = function() {
        if (!$scope.originProject || !$scope.originProject.drive_root_id) {
          return $q.reject('El proyecto origen no tiene carpeta de Google Drive');
        }

        return GoogleApi.findFolderByName($scope.originProject.drive_root_id, 'Requerimiento')
          .catch(function(error) {
            return $q.reject(driveError(error));
          })
          .then(function(folder) {
            if (!folder) {
              return $q.reject('No se encontró la carpeta de Requerimientos dentro de la carpeta del proyecto en Google Drive.');
            }
            return GoogleApi.uploadFileToFolder($scope.documentFile, folder.id)
              .catch(function(error) {
                return $q.reject(driveError(error));
              });
          });
      };

      $scope.saveRequest = function() {
        if ($scope.saving) { return; }
        $scope.saving = true;
        $scope.uploading = true;

        uploadDocument().then(function(uploaded) {
          $scope.uploading = false;

          angular.extend($scope.requestHash.scope_change_request, {
            'document_name': uploaded.name,
            'document_drive_id': uploaded.id,
            'document_drive_url': uploaded.webViewLink,
            'document_size': $scope.documentFile.size
          });

          return ScopeChangeRequest.save($scope.requestHash);
        }).then(function() {
          toaster.pop('success', 'Solicitud', 'La solicitud de cambio de alcance se registró correctamente');
          $state.go('app.projects.show', { projectId: $stateParams.projectId });
        }).catch(function(error) {
          $scope.saving = false;
          $scope.uploading = false;

          if (typeof error === 'string') {
            toaster.pop('error', 'Documento', error);
          } else if (error && error.data) {
            ScopeChangeRequest.error(error);
          } else {
            toaster.pop('error', 'Solicitud', 'No se pudo registrar la solicitud. Revise la consola del navegador.');
            console.error(error);
          }
        });
      };
  }]);
